export default Object.freeze({
  WIDGETS: "/administrator/widgets",
  CREATEWIDGETS: "/administrator/widgets/create",
  ASSIGNWIDGETS: "/widgets/assign",
  DASHBOARDCONFIG: "/administrator/dashboard/create",
  DASHBOARD: "/administrator/dashboard",
  USERDASHBOARD: "/supply-chain/dashboard/user",
  DASHBOARDVIEW: "/administrator/dashboard/view",
});
